import React from 'react';
import { Box } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { googleLogin } from '../../actions/auth-actions';

const GoogleLoginButton = () => {
  const dispatch = useDispatch();

  return (
    <Box sx={{ 
      width: '100%',
      '& > div': {
        width: '400px !important',
        maxWidth: '100% !important',
        margin: '0 auto !important',
        display: 'block',
      }
    }}>
      <GoogleLogin
        onSuccess={credentialResponse => {
          console.log('Google OAuth response:', credentialResponse);
          if (credentialResponse.credential) {
            dispatch(googleLogin(credentialResponse.credential));
          }
        }}
        onError={() => {
          console.error('Google login failed');
        }}
        useOneTap
        text="continue_with"
        shape="rectangular"
        size="large"
        width="400"
      />
    </Box>
  );
};

export default GoogleLoginButton; 